<div class="dialog-content-wrapper">
    <mat-toolbar class="mat-accent m-0">
        <mat-toolbar-row fxFlex fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">{{dialogTitle}}</span>
            <button mat-icon-button (click)="dialogRef.close()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 m-0" >
        <form name="eventForm" [formGroup]="eventForm" class="event-form w-100-p" fxLayout="column" fxFlex>

            <mat-form-field class="w-100-p">
                <input matInput
                       name="title"
                       formControlName="title"
                       placeholder="Title"
                       [readonly]= "!hasPermissionToEdit"
                       required>
            </mat-form-field>

            <div class="py-16" fxFlex="1 0 auto" fxLayout="row">
                <mat-slide-toggle
                    name="allDay"
                    formControlName="allDay"
                    class="mr-24"
                    [disabled]= "!hasPermissionToEdit"
                    aria-label="All day">
                    All Day
                </mat-slide-toggle>
            </div>

            <div class="py-16" fxFlex="1 0 auto" fxLayout="column" fxLayout.gt-xs="row" formGroupName="color">

                <mat-form-field class="mr-sm-24" fxFlex>
                    <input matInput
                    [readonly]= "!hasPermissionToEdit"
                           class="primary-color-input"
                           name="primary color"
                           formControlName="primary"
                           placeholder="Primary color"
                           [(colorPicker)]="event.color.primary"
                           cpWidth="290px"
                           [cpPresetColors]="presetColors"
                           [style.background]="event.color.primary"
                           (colorPickerChange)="event.color.primary = $event; eventForm.patchValue({color:{primary:$event}})"/>
                </mat-form-field>

                <mat-form-field fxFlex>
                    <input matInput
                    [readonly]= "!hasPermissionToEdit"
                           class="secondary-color-input"
                           name="secondary color"
                           formControlName="secondary"
                           placeholder="Secondary color"
                           [(colorPicker)]="event.color.secondary"
                           cpWidth="290px"
                           [cpPresetColors]="presetColors"
                           [style.background]="event.color.secondary"
                           (colorPickerChange)="event.color.secondary = $event; eventForm.patchValue({color:{secondary:$event}})"/>
                </mat-form-field>

            </div>

            <div fxFlex="1 0 auto" fxLayout="column" fxLayout.gt-xs="row">

                <mat-form-field class="mr-sm-24" fxFlex>
                    <input matInput [matDatepicker]="startDatePicker" placeholder="Start Date"
                           name="start"
                           [readonly]= "!hasPermissionToEdit"
                           formControlName="start">
                    <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #startDatePicker></mat-datepicker>
                </mat-form-field>

                <mat-form-field class="no-errors-spacer" fxFlex mat-no-float>
                    <input matInput placeholder="Start Time"  [readonly]= "!hasPermissionToEdit">
                </mat-form-field>

            </div>

            <div fxFlex="1 0 auto" fxLayout="column" fxLayout.gt-xs="row">

                <mat-form-field class="mr-sm-24" fxFlex>
                    <input matInput [matDatepicker]="endDatePicker" placeholder="End Date"
                           name="end"
                           [readonly]= "!hasPermissionToEdit"
                           formControlName="end">
                    <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #endDatePicker></mat-datepicker>
                </mat-form-field>

                <mat-form-field class="no-errors-spacer" fxFlex mat-no-float>
                    <input matInput placeholder="End Time"   [readonly]= "!hasPermissionToEdit">
                </mat-form-field>

            </div>

            <mat-form-field formGroupName="meta" class="w-100-p">
                <input matInput
                [readonly]= "!hasPermissionToEdit"
                       name="location"
                       formControlName="location"
                       placeholder="Location">
            </mat-form-field>
            

            <mat-form-field formGroupName="meta" class="w-100-p">

                <textarea matInput
                [readonly]= "!hasPermissionToEdit"
                          formControlName="notes"
                          placeholder="Notes"
                          mat-maxlength="250"
                          max-rows="4">
                </textarea>
            </mat-form-field>

        </form>

    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="space-between center">

        <button *ngIf="hasPermissionToEdit && action !=='edit'"
                mat-raised-button
                (click)="dialogRef.close(eventForm)"
                class="save-button mat-accent"
                [disabled]="eventForm.invalid"
                aria-label="SAVE">
            SAVE
        </button>

        <button *ngIf="hasPermissionToEdit && action ==='edit'"
                mat-raised-button
                (click)="dialogRef.close(['save',eventForm])"
                class="save-button mat-accent"
                [disabled]="eventForm.invalid"
                aria-label="SAVE">
            SAVE
        </button>

        <button *ngIf="hasPermissionToDelete && action ==='edit'"
                mat-icon-button
                (click)="dialogRef.close(['delete',eventForm])"
                aria-label="Delete"
                matTooltip="Delete">
            <mat-icon>delete</mat-icon>
        </button>
    </div>
</div>
